module.exports = __webpack_public_path__ + "static/media/incorrecto_val.e5e0ce6c.png";